// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as PlUtils from "../player/PlUtils.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as AugmentName from "common/src/tft-static/AugmentName.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as Belt_MutableMapString from "rescript/lib/es6/belt_MutableMapString.js";

function getCols(showLp) {
  return Belt_Array.concat([
              StatsTable2.col(false, undefined, (function (param, param$1) {
                      return param$1.t("Augment");
                    }), undefined, (function (param, param$1, param$2) {
                      var augId = param[0];
                      return React.createElement("div", {
                                  className: "flex items-center overflow-hidden"
                                }, React.createElement("div", {
                                      className: "flex-shrink-0"
                                    }, React.createElement(AugmentImage.make, {
                                          augId: augId,
                                          size: 29
                                        })), React.createElement("div", {
                                      className: "pl-2 truncate font-roboto font-normal"
                                    }, React.createElement(AugmentName.make, {
                                          id: augId
                                        })));
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      return param$2.augmentsT(param[0]);
                    }), undefined, 150, undefined, undefined),
              StatsTable2.col(undefined, true, (function (param, param$1) {
                      return param$1.t("Games");
                    }), undefined, (function (param, param$1, param$2) {
                      return String(param[1].count);
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      return param[1].count;
                    }), undefined, 80, undefined, undefined),
              StatsTable2.col(false, true, (function (param, param$1) {
                      return param$1.t("Place");
                    }), undefined, (function (param, param$1, param$2) {
                      return param[1].place.toFixed(2);
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      return param[1].place;
                    }), undefined, 75, undefined, undefined),
              StatsTable2.col(undefined, true, (function (param, param$1) {
                      return param$1.t("Top 4");
                    }), undefined, (function (param, param$1, param$2) {
                      var v = param[1];
                      return Global.formatPct(undefined, Global.f(v.top4) / Global.f(v.count)) + "%";
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      var v = param[1];
                      return Global.f(v.top4) / Global.f(v.count);
                    }), undefined, 75, undefined, undefined),
              StatsTable2.col(undefined, true, (function (param, param$1) {
                      return param$1.t("Win");
                    }), undefined, (function (param, param$1, param$2) {
                      var v = param[1];
                      return Global.formatPct(undefined, Global.f(v.top1) / Global.f(v.count)) + "%";
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      var v = param[1];
                      return Global.f(v.top1) / Global.f(v.count);
                    }), undefined, 75, undefined, undefined),
              StatsTable2.col(undefined, true, (function (param, param$1) {
                      return param$1.t("At 2-1");
                    }), undefined, (function (param, param$1, param$2) {
                      return Belt_Option.mapWithDefault(param[1].p21, "-", (function (v) {
                                    return Global.toFixed(undefined, v);
                                  }));
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      return param[1].p21;
                    }), undefined, 80, undefined, undefined),
              StatsTable2.col(undefined, true, (function (param, param$1) {
                      return param$1.t("At 3-2");
                    }), undefined, (function (param, param$1, param$2) {
                      return Belt_Option.mapWithDefault(param[1].p32, "-", (function (v) {
                                    return Global.toFixed(undefined, v);
                                  }));
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      return param[1].p32;
                    }), undefined, 80, undefined, undefined),
              StatsTable2.col(undefined, true, (function (param, param$1) {
                      return param$1.t("At 4-2");
                    }), undefined, (function (param, param$1, param$2) {
                      return Belt_Option.mapWithDefault(param[1].p42, "-", (function (v) {
                                    return Global.toFixed(undefined, v);
                                  }));
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      return param[1].p42;
                    }), undefined, 80, undefined, undefined)
            ], []);
}

function PlAugmentsSummary(Props) {
  var showLp = Props.showLp;
  var games = Props.games;
  var top = Props.top;
  var isDuo = Props.isDuo;
  var scrollRef = Props.scrollRef;
  var set = TftSet.use(undefined);
  var data = React.useMemo((function () {
          var augmentGroups = Belt_MutableMapString.make(undefined);
          var p21Groups = Belt_MutableMapString.make(undefined);
          var p32Groups = Belt_MutableMapString.make(undefined);
          var p42Groups = Belt_MutableMapString.make(undefined);
          Belt_Array.forEach(games, (function (hero) {
                  return Belt_Array.forEachWithIndex(Belt_Option.getWithDefault(hero.info.augments, []), (function (idx, id) {
                                var id$1 = Data.encodeAugmentId(id);
                                var group = Belt_MutableMapString.getWithDefault(augmentGroups, id$1, []);
                                var match = hero.rankBefore;
                                var match$1 = hero.rankAfter;
                                var rankChange;
                                var exit = 0;
                                if (match !== undefined && match$1 !== undefined) {
                                  var before = LpChartUtils.divisionToBase(match[0], set) + match[1] | 0;
                                  var after = LpChartUtils.divisionToBase(match$1[0], set) + match$1[1] | 0;
                                  rankChange = after - before | 0;
                                } else {
                                  exit = 1;
                                }
                                if (exit === 1) {
                                  rankChange = hero.queueId === 1100 ? PlUtils.getEstimatedLp(hero.info.placement) : 0;
                                }
                                group.push([
                                      hero.info.placement,
                                      rankChange
                                    ]);
                                Belt_MutableMapString.set(augmentGroups, id$1, group);
                                var groupMap;
                                switch (idx) {
                                  case 0 :
                                      groupMap = p21Groups;
                                      break;
                                  case 1 :
                                      groupMap = p32Groups;
                                      break;
                                  case 2 :
                                      groupMap = p42Groups;
                                      break;
                                  default:
                                    groupMap = p42Groups;
                                }
                                var curr = Belt_MutableMapString.getWithDefault(groupMap, id$1, [
                                      0,
                                      0
                                    ]);
                                return Belt_MutableMapString.set(groupMap, id$1, [
                                            curr[0] + 1 | 0,
                                            curr[1] + hero.info.placement | 0
                                          ]);
                              }));
                }));
          var augmentGroups$1 = Belt_SortArray.stableSortBy(Belt_MutableMapString.toArray(augmentGroups), (function (param, param$1) {
                  return -Caml.caml_int_compare(param[1].length, param$1[1].length) | 0;
                }));
          var augmentGroups$2 = Belt_SortArray.stableSortBy(Belt_Array.keep(augmentGroups$1, (function (param) {
                      return Belt_Option.isSome(Data.augmentInfo(param[0], set));
                    })), (function (tg1, tg2) {
                  return -Caml.caml_int_compare(tg1[1].length, tg2[1].length) | 0;
                }));
          var minCount = Caml.caml_int_min(5, Belt_Option.mapWithDefault(Belt_Array.get(augmentGroups$2, 24), 0, (function (param) {
                      return param[1].length;
                    })));
          var len = augmentGroups$2.findIndex(function (param) {
                return param[1].length < minCount;
              });
          var augmentGroups$3 = len === -1 ? augmentGroups$2 : Belt_Array.slice(augmentGroups$2, 0, len);
          return Belt_Array.map(augmentGroups$3, (function (param) {
                        var places = param[1];
                        var id = param[0];
                        var c = places.length;
                        var avg = Global.f(Belt_Array.reduce(places, 0, (function (acc, param) {
                                    var p = param[0];
                                    return acc + (
                                            isDuo ? T.duoPlace(p) : p
                                          ) | 0;
                                  }))) / Global.f(places.length);
                        var top4 = Belt_Array.keep(places, (function (param) {
                                var p = param[0];
                                if (p <= 4) {
                                  return p >= 1;
                                } else {
                                  return false;
                                }
                              })).length;
                        var win = Belt_Array.keep(places, (function (param) {
                                var p = param[0];
                                if (isDuo) {
                                  return p <= 2;
                                } else {
                                  return p === 1;
                                }
                              })).length;
                        var lp = Belt_Array.reduce(places, 0, (function (acc, param) {
                                return acc + param[1] | 0;
                              }));
                        return [
                                id,
                                {
                                  count: c,
                                  place: avg,
                                  top4: top4,
                                  top1: win,
                                  lp: lp,
                                  p21: Belt_Option.map(Belt_MutableMapString.get(p21Groups, id), (function (v) {
                                          return Global.f(v[1]) / Global.f(v[0]);
                                        })),
                                  p32: Belt_Option.map(Belt_MutableMapString.get(p32Groups, id), (function (v) {
                                          return Global.f(v[1]) / Global.f(v[0]);
                                        })),
                                  p42: Belt_Option.map(Belt_MutableMapString.get(p42Groups, id), (function (v) {
                                          return Global.f(v[1]) / Global.f(v[0]);
                                        }))
                                }
                              ];
                      }));
        }), [games]);
  var keyFn = React.useCallback((function (v) {
          return v[0];
        }), []);
  var cols = React.useMemo((function () {
          return getCols(showLp);
        }), [showLp]);
  return React.createElement(StatsTable2.make, {
              cols: cols,
              data: data,
              context: undefined,
              keyFn: keyFn,
              stickyColCount: 1,
              top: top,
              defaultSortIdx: 1,
              scrollEl: [
                scrollRef,
                0
              ]
            });
}

var make = React.memo(PlAugmentsSummary);

export {
  getCols ,
  make ,
  
}
/* make Not a pure module */
